import { Box, Text, Button, Image } from '@betty/moonlight';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { memo, useCallback } from 'react';

function FreeSpinsEmpty() {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handlePress = useCallback(() => {
    navigation.navigate('Shop');
  }, [navigation]);

  return (
    <Box
      width="100%"
      height={150}
      borderRadius="radius-400"
      justifyContent="center"
      alignItems="center"
      marginTop="space-200"
    >
      <Image
        name="rewards.background"
        width="100%"
        height="100%"
        contentFit="cover"
        borderRadius="radius-400"
        opacity={0.6}
        position="absolute"
        zIndex={1}
      />
      <Box paddingHorizontal="space-600" width="100%" zIndex={2}>
        <Text
          variant="body-m-semi"
          color="darkSurfacePrimary"
          textAlign="center"
          zIndex={2}
          locNS="rewards"
          locKey="emptyFreeSpinsTitle"
        />
      </Box>

      <Button
        variant="primary"
        size="small"
        marginTop="space-200"
        zIndex={2}
        onPress={handlePress}
        locNS="rewards"
        locKey="emptyFreeSpinsButton"
        rightIcon="arrowForward"
      />
    </Box>
  );
}

export default memo(FreeSpinsEmpty);
